import React, { SyntheticEvent, useState } from 'react';
import { Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { TooltipPlacement } from 'antd/es/tooltip';
import { toggleBillingModal } from '@redux/actions/modalAction';
import './UpgradePlanTooltip.less';

function UpgradePlanTooltip({
  children,
  text,
  textBefore,
  isCanVisible,
  innerStyle,
  isShowUpgradeText = true,
  beforeUpgradeClick,
  getPopupContainer,
  placement
}: {
  children: React.ReactChildren | React.ReactChild;
  textBefore?: React.ReactNode;
  text: string;
  isShowUpgradeText?: boolean;
  isCanVisible: boolean;
  innerStyle?: any;
  placement?: TooltipPlacement;
  getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;
  beforeUpgradeClick?(e: SyntheticEvent<HTMLSpanElement, MouseEvent>): void;
}) {
  const dispatch = useDispatch();
  const [isVisibleToolTip, setIsVisibleTooltip] = useState(false);

  return (
    <Tooltip
      open={isVisibleToolTip}
      onOpenChange={(visible) => setIsVisibleTooltip(isCanVisible && visible)}
      trigger="hover"
      autoAdjustOverflow={true}
      placement={placement || 'top'}
      overlayClassName="upgrade-plan-tooltip"
      overlayInnerStyle={innerStyle}
      getPopupContainer={getPopupContainer}
      title={
        <div>
          {textBefore}
          {isShowUpgradeText && (
            <>
              <span
                style={{
                  textDecoration: 'underline',
                  cursor: 'pointer'
                }}
                onClick={(e) => {
                  if (beforeUpgradeClick) beforeUpgradeClick(e);
                  dispatch(toggleBillingModal({ visible: true }));
                }}
              >
                Upgrade
              </span>{' '}
            </>
          )}
          {text}
        </div>
      }
    >
      {children}
    </Tooltip>
  );
}

export default UpgradePlanTooltip;
